import React from "react";
import { Card, CardContent, Button, Box, Typography } from "@mui/material";
import { EditNote as EditNoteIcon } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { useTheme } from "../../../contexts/ThemeContext";
import { useSystemButtonStyles } from "../../../hooks/useSystemButtonStyles";
import { getMm } from "../../../theme/modernMaterialEnterprise";

export const WarningCard = ({ setSelectedPage }) => {
  const { t } = useTranslation();
  const { isDarkMode } = useTheme();
  const {
    primaryButtonSx,
    cancelButtonSx,
    outlineButtonSx,
    secondaryButtonSx,
    destructiveButtonSx,
    destructiveOutlineButtonSx,
    greenSmileyButtonSx,
    redSmileyButtonSx,
    iconActionSx,
    iconActionTableSx,
    iconActionLargeSx,
    toolbarButtonSx,
    dialogPrimarySx,
    dialogCancelSx,
    dialogFormPrimarySx,
    dialogFormCancelSx,
    dialogFormDestructiveSx,
    warningButtonSx,
    buttonSx,
  } = useSystemButtonStyles();

  return (
    <Box sx={{ mb: { xs: 2.5, sm: 4 }, display: "flex", justifyContent: "center", width: "100%", px: { xs: 0, sm: 2 } }}>
      <Card
        sx={{
          maxWidth: 480,
          width: "100%",
          borderRadius: "8px",
          overflow: "hidden",
          boxShadow: "none",
          border: `1px solid ${getMm(isDarkMode).outlineVariant}`,
          backgroundColor: getMm(isDarkMode).surfaceLowest,
          fontFamily: "'Plus Jakarta Sans', system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
        }}
      >
        <CardContent sx={{ p: { xs: 2, sm: 4 }, textAlign: "center" }}>
          <Box
            sx={{
              width: 64,
              height: 64,
              borderRadius: '50%',
              backgroundColor: getMm(isDarkMode).outlineVariant,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              mx: 'auto',
              mb: 2
            }}
          >
            <EditNoteIcon
              sx={{
                fontSize: 32,
                color: getMm(isDarkMode).onSurface,
              }}
            />
          </Box>
          <Typography
            sx={{
              fontSize: '1.25rem',
              fontWeight: 700,
              color: getMm(isDarkMode).onSurface,
              mb: 1,
              fontFamily: "'Plus Jakarta Sans', sans-serif"
            }}
          >
            {t("update_needed_title")}
          </Typography>
          <Typography
            sx={{
              fontSize: '1rem',
              color: getMm(isDarkMode).onSurfaceVariant,
              lineHeight: 1.5,
              mb: 3,
              fontFamily: "'Plus Jakarta Sans', sans-serif"
            }}
          >
            {t("update_needed_text")}
          </Typography>
          <Button
            variant="contained"
            color="primary"
            fullWidth
            onClick={() => setSelectedPage("ProfilePage")}
            startIcon={<EditNoteIcon sx={{ fontSize: 20 }} />}
            sx={{
              ...primaryButtonSx,
              px: 4,
              py: 1.5,
              fontSize: "1rem",
              maxWidth: { sm: 320 },
              mx: { sm: "auto" },
            }}
          >
            {t("update_profile")}
          </Button>
        </CardContent>
      </Card>
    </Box>
  );
};
